/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiRole } from './InternalApiRole';
import {
    InternalApiRoleFromJSON,
    InternalApiRoleFromJSONTyped,
    InternalApiRoleToJSON,
    InternalApiRoleToJSONTyped,
} from './InternalApiRole';
import type { InternalApiAlertFilterExpression } from './InternalApiAlertFilterExpression';
import {
    InternalApiAlertFilterExpressionFromJSON,
    InternalApiAlertFilterExpressionFromJSONTyped,
    InternalApiAlertFilterExpressionToJSON,
    InternalApiAlertFilterExpressionToJSONTyped,
} from './InternalApiAlertFilterExpression';

/**
 * New and yet unsaved set of expressions that defines screening alerts search filter
 * @export
 * @interface InternalApiNewAlertFilter
 */
export interface InternalApiNewAlertFilter {
    /**
     * 
     * @type {string}
     * @memberof InternalApiNewAlertFilter
     */
    name: string;
    /**
     * 
     * @type {Array<InternalApiAlertFilterExpression>}
     * @memberof InternalApiNewAlertFilter
     */
    expressions: Array<InternalApiAlertFilterExpression>;
    /**
     * 
     * @type {Array<InternalApiRole>}
     * @memberof InternalApiNewAlertFilter
     */
    roles?: Array<InternalApiRole>;
}

/**
 * Check if a given object implements the InternalApiNewAlertFilter interface.
 */
export function instanceOfInternalApiNewAlertFilter(value: object): value is InternalApiNewAlertFilter {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expressions' in value) || value['expressions'] === undefined) return false;
    return true;
}

export function InternalApiNewAlertFilterFromJSON(json: any): InternalApiNewAlertFilter {
    return InternalApiNewAlertFilterFromJSONTyped(json, false);
}

export function InternalApiNewAlertFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiNewAlertFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'expressions': ((json['expressions'] as Array<any>).map(InternalApiAlertFilterExpressionFromJSON)),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(InternalApiRoleFromJSON)),
    };
}

export function InternalApiNewAlertFilterToJSON(json: any): InternalApiNewAlertFilter {
    return InternalApiNewAlertFilterToJSONTyped(json, false);
}

export function InternalApiNewAlertFilterToJSONTyped(value?: InternalApiNewAlertFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'expressions': ((value['expressions'] as Array<any>).map(InternalApiAlertFilterExpressionToJSON)),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(InternalApiRoleToJSON)),
    };
}

